import { createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GRAPHQL_ENDPOINT } from '../../config';
/**
 * The most common Apollo link. Used to fetch GraphQL results from our
 * provided GraphQL endpoint. This link supports both POST and GET requests.
 */

export function createGraphqlLink({
  env
}) {
  return createHttpLink({
    uri: GRAPHQL_ENDPOINT({
      env
    })
  });
}
/**
 * createAuthLink
 * Create the auth link that gets added to each graphql request
 * 
 */

export function createAuthLink({
  bearerToken
}) {
  return setContext((_, {
    headers
  }) => {
    const accessToken = 'Bearer ' + bearerToken; // Return headers to the context so httpLink can read them

    return {
      headers: { ...headers,
        authorization: accessToken
      }
    };
  });
}
//# sourceMappingURL=apolloLinks.js.map